module.exports = __webpack_public_path__ + "img/title-bg.f8aea037.png";